import { Component, Inject, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SelectModule } from 'primeng/select';
import { DataVoidComponent } from '@app/shared/components/data-void/data-void.component';
import { Pagination } from '@app/shared/components/api/models/pagination.model';
import {
  TableComponent,
  TableColumn,
} from '@app/shared/components/table/table.component';
import { MenuItem, MessageService } from 'primeng/api';

import { FormBuilder, ReactiveFormsModule, FormGroup } from '@angular/forms';
import { DialogModule } from 'primeng/dialog';
import { FilterItem } from '@app/shared/components/api/models/filterItem.model';
import { SearchBarComponent } from '@app/shared/components/search-bar/search-bar.component';
import { forkJoin } from 'rxjs';
import { LogsService } from '@app/shared/components/api/services/logs.service';
import { format } from 'date-fns';
import { EnumService } from '@app/shared/components/api/services/enum.service';
import { BackButtonComponent } from '@app/shared/components/back-button/back-button.component';
import { JsonTreeComponent } from '@app/shared/components/json-tree/json-tree.component';

@Component({
  selector: 'app-logs',
  imports: [
    CommonModule,
    SelectModule,
    DataVoidComponent,
    TableComponent,
    ReactiveFormsModule,
    DialogModule,
    SearchBarComponent,
    BackButtonComponent,
    JsonTreeComponent,
  ],
  providers: [LogsService],
  templateUrl: './logs.component.html',
  styleUrl: './logs.component.scss',
})
export class LogsComponent implements OnInit {
  logsService = inject(LogsService);
  messageService = Inject(MessageService);
  enumService = inject(EnumService);
  fb = inject(FormBuilder);
  showFilter: boolean = false;
  showDetalhe: boolean = false;
  form!: FormGroup;
  formLog!: FormGroup;
  listAtivitys: any[] = [];
  listEntidades: any[] = [];
  logsCount: any;
  registo: any;
  jsonLog: any;
  pagination: Pagination<any> = new Pagination<any>().deserialize({
    data: [],
    totalRecords: 0,
    pageNumber: 1,
    pageSize: 5,
  });

  execucaoList = [
    { label: 'Sucesso', value: true },
    { label: 'Falha', value: false },
  ];
  filters: FilterItem[] = [
    {
      type: 'text',
      controlName: 'user',
      placeholder: 'Utilizador',
    },
    {
      type: 'dropdown',
      controlName: 'AcaoLogsEnum',
      placeholder: 'Acção realizada',
      options: this.listAtivitys,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'execucao',
      placeholder: 'Execução',
      options: this.execucaoList,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'dropdown',
      controlName: 'EntidadeEnum',
      placeholder: 'Entidade',
      options: this.listEntidades,
      optionLabel: 'label',
      optionValue: 'id',
    },
    {
      type: 'date',
      controlName: 'date',
      placeholder: 'Data & Hora',
      optionLabel: 'label',
      optionValue: 'value',
    },
  ];

  columns: TableColumn[] = [
    {
      field: 'username',
      header: 'Utilizador',
      tooltip: 'Utilizador',
      type: 'text',
    },
    {
      field: 'entidade',
      header: 'Entidade',
      tooltip: 'Entidade',
      type: 'text',
    },
    { field: 'acaoRealizada', header: 'Acção', tooltip: 'Acção', type: 'text' },
    {
      field: 'sucesso',
      header: 'Execução',
      type: 'tag',
      formatter: (value: boolean) => (value ? 'Sucesso' : 'Falha'),
      tagSeverityFunction: (row: any) => (row.sucesso ? 'success' : 'danger'),
    },
    {
      field: 'dataCriacao',
      header: 'Data',
      tooltip: 'Data',
      type: 'text',
      formatter: (value: string) => format(new Date(value), 'dd/MM/yyyy HH:mm'),
    },
  ];

  actions: MenuItem[] = [
    {
      label: 'Detalhe',
      icon: 'pi pi-info-circle',
      command: ($event: any) => this.getDetalhe($event.item.data),
    },
  ];

  ngOnInit(): void {
    this.loadLogs();
    this.loadDropdowns();

    this.form = this.fb.group({
      user: [null],
      AcaoEnum: [null],
      execucao: [null],
      EntidadeEnum: [null],
      date: [null],
    });

    this.formLog = this.fb.group({
      nome: [{ value: '', disabled: true }],
      email: [{ value: '', disabled: true }],
      dataFormata: [{ value: '', disabled: true }],
      acao: [{ value: '', disabled: true }],
      sucesso: [{ value: '', disabled: true }],
    });
  }

  loadLogs(filters?: any) {
    const params = {
      ...filters,
      pageNumber: this.pagination.pageNumber ?? 1,
      pageSize: this.pagination.pageSize ?? 5,
      orderBy: filters?.orderBy || 'id desc',
    };

    this.logsService.list(params).subscribe({
      next: (result: any) => {
        this.pagination = new Pagination<any>().deserialize(result);
        this.logsCount = this.pagination?.totalRecords;
      },
      error: (error: any) => {
        console.error('Erro ao buscar registos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar registos.',
        });
      },
      complete: () => {},
    });
  }

  getDetalhe(log: any) {
    this.logsService.show(log?.id).subscribe({
      next: (result: any) => {
        this.registo = result;
        this.jsonLog = result;
        this.formLog.patchValue({
          nome: log?.nome,
          email: log?.email,
          dataFormata: this.registo?.DataCriacao
            ? format(new Date(this.registo.DataCriacao), 'dd/MM/yyyy HH:mm')
            : '',
          acao: log?.acaoLogs,
          sucesso: log?.sucesso ? 'Sucesso' : 'Falha',
        });
      },
      error: (error: any) => {
        console.error('Erro ao buscar registos:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao buscar registos.',
        });
      },
    });
    this.showDetalhe = true;
  }

  copiarJson() {
    if (!this.jsonLog) return;
    const jsonString = JSON.stringify(this.jsonLog, null, 2);
    navigator.clipboard.writeText(jsonString).then(() => {
      this.messageService?.add?.({
        severity: 'success',
        summary: 'Copiado',
        detail: 'Payload JSON copiado para a área de transferência!',
        life: 3000,
      });
    });
  }

  handleFormValueChange(event: any) {
    const filters = Object.fromEntries(
      Object.entries(event).filter(
        ([_, value]) => value !== null && value !== undefined && value !== '',
      ),
    );
    this.loadLogs(filters);
    this.showFilter = false;
  }

  loadDropdowns() {
    forkJoin({
      ativitys: this.enumService.getAllAtivitysLog(),
      entidadesEnums: this.enumService.getAllEntidade(),
    }).subscribe((response) => {
      // Enums
      if (response.ativitys?.data) {
        this.listAtivitys = Object.entries(response.ativitys.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[1].options = this.listAtivitys;
      }
      if (response.entidadesEnums?.data) {
        this.listEntidades = Object.entries(response.entidadesEnums.data).map(
          ([key, value]) => ({
            id: Number(key),
            label: value,
          }),
        );
        this.filters[3].options = this.listEntidades;
      }
    });
  }

  onPageChange(event: any) {
    this.pagination.pageNumber = event.page + 1;
    this.pagination.pageSize = event.rows;
    this.loadLogs(event);
  }
}
